






























































import {
  apiMerchantStoreGetStoreIntroduction,
  apiSearchMartSearchSearchCommodity,
} from '@/api'
import { computed, ref } from '@vue/composition-api'
import { defineClassComponent, useApi, useLoaded, useQuery } from '@/hooks'
import { defineTvListeners } from '../utils'
import { makeUniGoods, prepareData, Track, UniGoods } from '@/utils'
import { navigateTo } from '@/router'
import { useWaterfall, XWaterfallLoad } from '@/components'

export default defineClassComponent(
  ({ ctx }) =>
    class {
      constructor() {
        Track.useMark(() => ({
          // 埋点页面名称
          page: 'TV-店铺首页',
        }))

        useLoaded(this.loading, () => this.goToFilter(0))
      }

      // 加载状态
      loading = computed(() => this.apiData.loading)

      query = useQuery<{
        // 店铺 ID
        id: string
      }>()

      // 筛选条件索引
      filterConditionIndex = ref(0)

      apiData = useApi(() => {
        return prepareData({
          martData: apiMerchantStoreGetStoreIntroduction({
            storeId: this.query.id,
          }),
        })
      })

      martData = computed(() => this.apiData.data.martData)

      total = ref(0)

      waterfall = useWaterfall('waterfall', {
        reloadWatcher: () => this.filterConditionIndex.value,
      })

      // 加载列表数据
      loadData: XWaterfallLoad = ({ pageNumber }) => {
        return apiSearchMartSearchSearchCommodity({
          pageIndex: pageNumber,
          pageSize: 15,
          refMerchantId: this.query.id,
          sceneId: '55f9be7e73c04949bfa7a0c850d33924',
          sortType:
            // 综合
            this.filterConditionIndex.value === 0
              ? '02'
              : // 价格高到低
              this.filterConditionIndex.value === 1
              ? '04'
              : // 价格低到高
              this.filterConditionIndex.value === 2
              ? '03'
              : // 销量高到低
              this.filterConditionIndex.value === 3
              ? '01'
              : // 销量低到高
                '00',
        }).then(res => {
          this.total.value = res.total!
          return makeUniGoods(res.list!)
        })
      }

      // 跳到筛选栏
      goToFilter = (index: number) => {
        ctx.$tv.goTo(ctx.$refs.filter as any, index)
      }

      // 跳到头部
      goToList = (index: number) => {
        ctx.$tv.goTo((ctx.$refs.list as any).$el, index)
      }

      // 筛选栏监听器
      filterListeners = defineTvListeners(({ type, index, isLast }) => {
        switch (type) {
          case 'focus':
            this.filterConditionIndex.value = index
            break
          case 'right':
            if (isLast) {
              this.goToList(0)
            }
            break
          default:
            break
        }
      })

      // 列表监听器
      listListeners = defineTvListeners<UniGoods>(
        ({ type, index, isFirst, isLast, item }) => {
          switch (type) {
            case 'up':
              if (index < 5) {
                this.goToFilter(this.filterConditionIndex.value)
              }
              break
            case 'left':
              if (isFirst) {
                this.goToFilter(this.filterConditionIndex.value)
              } else {
                this.goToList(index - 1)
              }
              break
            case 'right':
              if (!isLast) {
                this.goToList(index + 1)
              } else {
                this.goToList(-1)
              }
              break
            case 'click':
              navigateTo('TvGoodsIndex', {
                id: item.id,
              })
              break
            default:
              break
          }
        },
      )
    },
)
